import React from 'react';
import PropTypes from 'prop-types';

import loading from '../assets/img/loading.gif';

export default class ImagePreloader extends React.PureComponent {
    static propTypes = {
        images: PropTypes.arrayOf(PropTypes.string).isRequired,
        displayLoading: PropTypes.bool.isRequired,
        children: PropTypes.node
    };

    static defaultProps = {
        displayLoading: true
    };

    state = {
        loaded: false
    };

    componentWillMount() {
        let promises = this.props.images.map((url) => {
            return new Promise((resolve, reject) => {
                let imgEl = document.createElement('img');
                imgEl.onload = resolve;
                imgEl.onerror = reject;

                imgEl.src = url;
            });
        });

        Promise.all(promises)
            .then(() => this.setState({loaded: true}))
            .catch((err) => {
                console.error('could not preload images', err);
                this.setState({loaded: true});  
            });
    }

    renderLoading() {
        return (
            <div className="loading-container">
                <img src={loading} />
            </div>
        );
    }

    render() {
        if (!this.state.loaded && this.props.displayLoading) {
            return this.renderLoading();
        }

        return this.props.children;
    }
}


// WEBPACK FOOTER //
// ./src/components/image-preloader.js